import { TranslationModule } from '../translation/translation.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MainComponent} from "./main.component";

import {LayoutModule} from "../Layouts/layout.module";
import {GlobalModule} from "../Global/global.module";
import {RouterOutlet} from "@angular/router";



@NgModule({
  declarations: [MainComponent],
  imports: [
    TranslationModule,
    CommonModule,
    LayoutModule,
    GlobalModule,
    RouterOutlet
  ],
 
})
export class MainModule { }
